import { MutationTree } from "vuex";
import { ISearchResult, IState } from "./state";
import { ActionPayload, IToggleFilterPayload } from "./actions";

export interface ShouldFocusPayload {
  shouldFocus: boolean;
  index: number;
}

type MutationHandler<PayloadType> = (
  state: IState,
  payload: ActionPayload<PayloadType>
) => any;

const setStateMutation: MutationHandler<IState> = (state, { payload }) => {
  Object.assign(state, payload);
};
const increasePageMutation: MutationHandler<IState> = (state, { payload }) => {
  Object.assign(state, { currentPage: state.currentPage + 1 });
};
const setPageMutation: MutationHandler<number> = (state, { payload }) => {
  Object.assign(state, { currentPage: payload });
};
const setQueryMutation: MutationHandler<string> = (state, { payload }) => {
  state.query = payload;
};
const newSearchMutation: MutationHandler<ISearchResult> = (
  state,
  { payload }
) => {
  state.currentPage = 0;
  state.searchResult = payload;
};
const toggleFilterMutation: MutationHandler<IToggleFilterPayload> = (
  state,
  { payload }
) => {
  const filterGroup = payload.group || "areaFilter";
  const filter = state[filterGroup].find((f) => f.id === payload.id);
  if (filter) {
    filter.selected = payload.value;
  }
};
const deselectAllFiltersMutation: MutationHandler<undefined> = (
  state,
  { payload }
) => {
  state.areaFilter.forEach((f) => (f.selected = false));
  state.statusFilter.forEach((f) => (f.selected = false));
  state.currentPage = 0;
};
const shouldFocusMutation: MutationHandler<ShouldFocusPayload> = (
  state,
  { payload }
) => {
  state.focus = payload;
};
const setSearchedQueryMutation: MutationHandler<undefined> = (
  state,
  { payload }
) => {
  state.searchedQuery = state.query;
};
const setSuggestionMutation: MutationHandler<string> = (state, { payload }) => {
  state.suggestion = payload;
};
const setAmountOfShowingHitsMutation: MutationHandler<number> = (
  state,
  { payload }
) => {
  state.amountOfShowingHits = payload;
};
const setCurrentlyShowingHitsMutation: MutationHandler<any> = (
  state,
  { payload }
) => {
  state.currentlyShowingHits = payload;
};

const mutations: MutationTree<IState> = {
  setState: setStateMutation,
  increasePage: increasePageMutation,
  setPage: setPageMutation,
  setQuery: setQueryMutation,
  newSearch: newSearchMutation,
  toggleFilter: toggleFilterMutation,
  deselectAllFilters: deselectAllFiltersMutation,
  shouldFocus: shouldFocusMutation,
  setSearchedQuery: setSearchedQueryMutation,
  setSuggestion: setSuggestionMutation,
  setAmountOfShowingHits: setAmountOfShowingHitsMutation,
  setCurrentlyShowingHits: setCurrentlyShowingHitsMutation,
};

export default mutations;
